import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    jobs: { Success: false, Data: [] },
    status: 'idle',
    error: null,
    dateRange: [],
};

export const fetchJobs = createAsyncThunk('jobs/getJobs', async () => {
    const response = await axios.get(
        `${process.env.REACT_APP_API_GATEWAY}/jobs`,
        {
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return response.data;
});

const jobsSlice = createSlice({
    name: 'job',
    initialState,
    reducers: {
        jobAdded(state, action) {
            const {
                pk1,
                sk1,
                schoolName,
                schoolLogo,
                schoolSummary,
                location,
                lat,
                lng,
                postDate,
                jobSummary,
                jobTitle,
                expiryDate,
                typeOfJob,
                attachmentUrl,
            } = action.payload;
            const currentJob = state.job;
            if (currentJob) {
                currentJob.pk1 = pk1;
                currentJob.sk1 = sk1;
                currentJob.schoolName = schoolName;
                currentJob.schoolLogo = schoolLogo;
                currentJob.schoolSummary = schoolSummary;
                currentJob.location = location;
                currentJob.lat = lat;
                currentJob.lng = lng;
                currentJob.postDate = postDate;
                currentJob.jobSummary = jobSummary;
                currentJob.jobTitle = jobTitle;
                currentJob.expiryDate = expiryDate;
                currentJob.typeOfJob = typeOfJob;
                currentJob.attachmentUrl = attachmentUrl;
            }
        },
    },
    extraReducers: {
        [fetchJobs.pending]: (state, action) => {
            state.status = 'loading';
        },
        [fetchJobs.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.jobs = action.payload.Message;
        },
    },
});

export default jobsSlice.reducer;

export const getJobs = state => state.jobs;
